module.exports = __webpack_public_path__ + "static/img/h1-1.20b6da7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/h1-1.png
// module id = vjH9
// module chunks = 1